module.exports = __webpack_public_path__ + "img/2.e16b596b.jpg";